import * as yup from 'yup';

export const profileFormSchema = yup.object({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  mobilePhone: yup.string().required(),
});
